<app-page>
  <app-page-header pageTitle="Clients">
    <pill *ngIf="clientCount" class="ms-2" [value]="clientCount ?? 0" after-title />
  </app-page-header>
  <app-page-content>
    <div class="table-options d-flex justify-content-between">
      <span></span>
      <span>
        <app-ag-grid-clear-column-filters-button *ngIf="clientsTable.columnFilterApplied$ | async" [gridApi]="clientsTable.gridApi" />
        <input type="text" class="form-input form-input--search" (keyup)="applySearch($event)" placeholder="Search" />
      </span>
    </div>

    <app-clients-table #clientsTable [searchValue]="searchValue" />
  </app-page-content>
</app-page>
